module.exports = __webpack_public_path__ + "img/stones.d3ce001.webp";